/* ============================================================
   DATE PUNCH — additive motion JS. Guarded, reduced-motion aware.
   ============================================================ */
(function(){
  if(window.__dpPunch) return; window.__dpPunch = 1;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bubbles(){
    var hero = document.querySelector('.dr-hero'); if(!hero || reduce) return;
    if(hero.querySelector('.dp-bubbles')) return;
    var wrap = document.createElement('div'); wrap.className = 'dp-bubbles';
    for(var i=0;i<22;i++){
      var b = document.createElement('span'); b.className = 'dp-bubble';
      var size = 4 + Math.random()*11;
      b.style.width = size+'px'; b.style.height = size+'px';
      b.style.left = (Math.random()*100)+'%';
      b.style.animationDuration = (7 + Math.random()*6)+'s';
      b.style.animationDelay = (Math.random()*8)+'s';
      b.style.setProperty('--dp-drift', ((Math.random()*40)-20)+'px');
      wrap.appendChild(b);
    }
    hero.insertBefore(wrap, hero.firstChild);
  }

  function headline(){
    var h = document.querySelector('.dr-hero__title'); if(!h) return;
    if(reduce){ h.classList.add('dp-headline-in'); return; }
    if(h.dataset.dpDone) return; h.dataset.dpDone = '1';
    var nodes = [].slice.call(h.childNodes), wi = 0, frag = document.createDocumentFragment();
    function wrapText(text, container){
      text.split(/(\s+)/).forEach(function(tok){
        if(tok.trim()===''){ container.appendChild(document.createTextNode(tok)); return; }
        var w = document.createElement('span'); w.className='dp-word';
        var inner = document.createElement('span'); inner.textContent = tok;
        inner.style.setProperty('--dp-wi', wi++);
        w.appendChild(inner); container.appendChild(w);
      });
    }
    nodes.forEach(function(n){
      if(n.nodeType===3){ wrapText(n.textContent, frag); }
      else if(n.nodeType===1){ var clone = n.cloneNode(false); wrapText(n.textContent, clone); frag.appendChild(clone); }
    });
    h.innerHTML=''; h.appendChild(frag);
  }

  function heroEnter(){
    var copy = document.querySelector('.dr-hero__copy');
    var title = document.querySelector('.dr-hero__title');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      if(title) title.classList.add('dp-headline-in');
      if(copy) copy.classList.add('dp-copy-in');
    }); });
  }

  function reveal(){
    var sel = ['.section-header','.flavor-split','.flavor-split-text','.sense-card','.heritage-story-grid','.heritage-img-card','.heritage-stat-card','.dr-pack','.dr-benefit','.dr-quote','.dr-trust__img','.dr-buy__head','.dr-ctaband__inner','.stats-bar-inner','.dr-shophero__inner','.section-cta'].join(',');
    var els = [].slice.call(document.querySelectorAll(sel)).filter(function(e){ return !e.classList.contains('dr-reveal') && !e.closest('.dr-hero'); });
    var seen = new Map();
    els.forEach(function(e){
      e.classList.add('dp-rv');
      if(e.matches('.heritage-img-card,.dr-pack,.dr-benefit')) e.classList.add('dp-rv--scale');
      var p = e.parentNode; var idx = seen.get(p)||0; e.style.setProperty('--dp-i', idx); seen.set(p, idx+1);
    });
    if(reduce || !('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('dp-in');}); return; }
    var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('dp-in'); io.unobserve(x.target); } }); },{threshold:.12, rootMargin:'0px 0px -50px 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function tags(){
    var box = document.querySelector('.flavor-split-text'); if(!box) return;
    if(reduce || !('IntersectionObserver' in window)){ box.classList.add('dp-tags-in'); return; }
    new IntersectionObserver(function(en,ob){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('dp-tags-in'); ob.unobserve(x.target);} }); },{threshold:.3}).observe(box);
  }

  function trustCounts(){
    [].slice.call(document.querySelectorAll('.dr-hero__trust b')).forEach(function(b){
      var m = (b.textContent||'').match(/^(\d+)(\D*)$/);
      if(!m || reduce) return;
      var target = parseInt(m[1],10), suffix = m[2]||'';
      if(target===0) return;
      b.textContent = '0'+suffix; var started=false;
      new IntersectionObserver(function(en,ob){ en.forEach(function(x){ if(!x.isIntersecting||started) return; started=true; ob.unobserve(b);
        var s=performance.now(),d=1100;
        (function a(n){var p=Math.min((n-s)/d,1),e=1-Math.pow(1-p,3); b.textContent=Math.round(target*e)+suffix; if(p<1)requestAnimationFrame(a); else b.textContent=target+suffix;})(s);
      }); },{threshold:.6}).observe(b);
    });
  }

  function canSpin(){
    var stage=document.getElementById('dpStage'), canvas=document.getElementById('dpCanvas'), video=document.getElementById('dpVideo');
    if(!stage||!canvas||!video) return;
    var turn=stage.closest('.dp-turn')||document;
    var revBtn=turn.querySelector('[data-dp-rev]'), pp=turn.querySelector('[data-dp-pp]'), speed=turn.querySelector('[data-dp-speed]');
    var ctx=canvas.getContext('2d',{willReadFrequently:true});
    var dir=1, paused=false, dragging=false, lastX=0, lastT=0;
    function rate(){ return speed ? 0.25+(speed.value/100)*2.25 : 1; }
    function sized(){ if(video.videoWidth && canvas.width!==video.videoWidth){ canvas.width=video.videoWidth; canvas.height=video.videoHeight; } }
    function keyDraw(){
      sized(); if(!video.videoWidth) return;
      ctx.drawImage(video,0,0,canvas.width,canvas.height);
      var im; try{ im=ctx.getImageData(0,0,canvas.width,canvas.height); }catch(e){ return; }
      var d=im.data;
      for(var i=0;i<d.length;i+=4){ var r=d[i],g=d[i+1],b=d[i+2];
        var mx=r>g?(r>b?r:b):(g>b?g:b), mn=r<g?(r<b?r:b):(g<b?g:b), sat=mx-mn;
        if(mx>200&&sat<28){ d[i+3]=0; } else if(mx>175&&sat<40){ d[i+3]=Math.round(255*((255-mx)/80)); } }
      ctx.putImageData(im,0,0);
    }
    function applyMode(){
      if(reduce||paused||dragging||dir<0){ video.pause(); return; }
      if(video.paused){ var pr=video.play(); if(pr&&pr.catch) pr.catch(function(){}); }
      video.playbackRate=rate();
    }
    function loop(t){
      if(!dragging && !paused && !reduce && dir<0 && video.duration){
        var dt=Math.min(0.05,(t-lastT)/1000||0);
        video.currentTime=(video.currentTime-rate()*dt+video.duration)%video.duration;
      }
      lastT=t; keyDraw(); requestAnimationFrame(loop);
    }
    function px(e){ return e.touches?e.touches[0].clientX:e.clientX; }
    function down(e){ dragging=true; stage.classList.add('dp-grab'); lastX=px(e); applyMode(); }
    function move(e){ if(!dragging||!video.duration) return; var x=px(e), dx=x-lastX; lastX=x;
      if(dx!==0) dir=dx>0?1:-1;
      video.currentTime=(video.currentTime+dx*0.012+video.duration)%video.duration;
      if(e.touches&&e.cancelable) e.preventDefault(); }
    function up(){ if(!dragging) return; dragging=false; stage.classList.remove('dp-grab'); applyMode(); }
    video.addEventListener('loadeddata',function(){ sized(); applyMode(); });
    stage.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
    stage.addEventListener('touchstart',down,{passive:true}); window.addEventListener('touchmove',move,{passive:false}); window.addEventListener('touchend',up);
    if(revBtn) revBtn.addEventListener('click',function(){ dir*=-1; applyMode(); });
    if(pp) pp.addEventListener('click',function(){ paused=!paused; applyMode();
      pp.innerHTML = paused ? '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>'; });
    if(speed) speed.addEventListener('input',applyMode);
    var p=video.play(); if(p&&p.catch) p.catch(function(){});
    requestAnimationFrame(loop);
  }

  function boot(){ bubbles(); headline(); reveal(); tags(); trustCounts(); canSpin(); heroEnter(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

/* ===== Back-to-top button (site-wide, self-contained) ===== */
(function(){
  function init(){
    if(document.getElementById('dp-top')) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var s=document.createElement('style');
    s.textContent='#dp-top{position:fixed;right:20px;bottom:22px;z-index:70;width:48px;height:48px;border:0;border-radius:50%;cursor:pointer;display:grid;place-items:center;background:linear-gradient(135deg,#E61348,#633097);box-shadow:0 8px 24px rgba(230,19,72,.4);opacity:0;transform:translateY(16px) scale(.9);pointer-events:none;transition:opacity .35s ease,transform .35s cubic-bezier(.22,1,.36,1),box-shadow .25s ease}#dp-top.dp-show{opacity:1;transform:none;pointer-events:auto}#dp-top:hover{transform:translateY(-3px);box-shadow:0 12px 32px rgba(230,19,72,.55)}#dp-top svg{width:22px;height:22px}@media (prefers-reduced-motion:reduce){#dp-top{transition:opacity .2s ease}}@media (max-width:600px){#dp-top{right:14px;bottom:16px;width:44px;height:44px}}';
    document.head.appendChild(s);
    var btn=document.createElement('button'); btn.id='dp-top'; btn.type='button'; btn.setAttribute('aria-label','Back to top');
    btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);
    var ticking=false;
    function upd(){ btn.classList.toggle('dp-show', window.scrollY>500); ticking=false; }
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(upd); ticking=true; } }, {passive:true});
    btn.addEventListener('click', function(){ window.scrollTo({top:0, behavior: reduce ? 'auto' : 'smooth'}); });
    upd();
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
